<template>
  <div>
    <div class="row mb-4">
      <div
        v-if="profile ==='SUPPLIER'"
        class="col-md col-6 mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'sales'})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/sales.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.satVReytinq') }}</h6>
              <p>{{ $t('myCabinetMenu.qeydAlnmSatlarnzVSatnalmalarnQiymtlndirilmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile ==='PROCUREMENT'"
        class="col-md col-6 mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'purchases'})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/purcahse.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.alVReytinq') }}</h6>
              <p>{{ $t('myCabinetMenu.qeydAlnmAllarnzVTdarklrinQiymtlndirilmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md col-12 mb-3">
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'myRequests', query:{status: 'ALL'}})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/requests.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6 class="f-w-600">
                {{ $t('myCabinetMenu.sorular') }}
              </h6>
              <p>{{ $t('myCabinetMenu.trfinizdnPlatformadaYerldirilmiSorularnIdaretmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile !=='PROCUREMENT' && (isAdmin || companyUserStatus==='verified') "
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementOutgoingRequests'})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/vendor-reqeusts.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.tdarkMracitlrim') }}</h6>
              <p>{{ $t('myCabinetMenu.tdarkDyrlndirmFormalarnaGndrdiyinizMracitlr') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile !=='PROCUREMENT' && (isAdmin || companyUserStatus==='verified') "
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementCustomerRequests'})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/customer-requests.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6>
                {{ $t('myCabinetMenu.mtrilriminSorular') }}
                <span class="badge bg-success blink">
                  <img src="@/assets/images/icons/bolt.png" alt="bolt">
                  {{ $t('myCabinetMenu.yeni') }}
                </span>
              </h6>
              <p>
                {{ $t('myCabinetMenu.tsdiqlnmiTdarksOlduunuzTkilatlarnSorular') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile ==='PROCUREMENT' && (isAdmin || companyUserStatus==='verified') "
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementDashboard'})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/vendors.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.tdarklrinIdarEdilmsi') }}</h6>
              <p>{{ $t('myCabinetMenu.tdarkDyrlndirmFormalarVTdarklrinIdaredilmsi') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile ==='PROCUREMENT' && (isAdmin || companyUserStatus==='verified') "
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementReports'})"
        >
          <div class="card-body cabinet-item">
            <img
              src="../../assets/images/icons/dashboard/reports.png"
              class="cabinet-item-icon"
              alt="cabinet-item-icon"
            >
            <div>
              <h6>{{ $t('myCabinetMenu.hesabatlar') }}</h6>
              <p>{{ $t('myCabinetMenu.qiymtSorularVAllarlaBalHesabatlar') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getProfileName} from "@/repositories/Utils";
import {mapState} from "vuex";

export default {
  name: 'MyCabinetMenu',
  props: {
    profile: {},
    requestStatusStatistics: {}
  },
  computed: {
    ...mapState({
      isAdmin: state => state.auth.isAdmin,
      companyUserStatus: state => state.auth.companyUserStatus,
    })
  },
  methods: {
    getProfileName(keyword) {
      return getProfileName(keyword,this.$i18n);
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme/_variables.scss";

.cabinet-item {
  font-size: 14px;
  display: flex;
  align-items: start;
  justify-content: start;

  .cabinet-item-icon {
    width: 50px;
    margin-right: 20px;
  }

  h6 {
    font-size: 16px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    margin-bottom: 0;
    color: $theme-body-sub-title-color;
  }
}
</style>
